var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"breadcrumb",on:{"click":function($event){_vm.navigate(-1)}}},[_vm._v("\n    Fichiers\n  ")]),_vm._v(" "),_vm._l((_vm.path),function(node,i){return _c('span',{key:node.id,staticClass:"breadcrumb",on:{"click":function($event){_vm.navigate(i)}}},[_vm._v("\n    "+_vm._s(node.name)+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5824a1f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/files/components/PathBreadcrumbs.vue
// module id = null
// module chunks = 